import React from "react";

export default function ScheduleAppointmentModal({ show, onClose, selectedPatientForSchedule, scheduleAppointmentForm, setScheduleAppointmentForm, onSubmit, doctors }) {
  if (!show || !selectedPatientForSchedule) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Schedule Appointment - {selectedPatientForSchedule.name}</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>Doctor *</label>
            <select
              required
              value={scheduleAppointmentForm.doctor_id}
              onChange={(e) => setScheduleAppointmentForm({...scheduleAppointmentForm, doctor_id: e.target.value})}
            >
              <option value="">Select Doctor</option>
              {doctors.map(d => (
                <option key={d.user_id} value={d.user_id}>
                  {d.display_name || d.user_name} {d.role_specialization ? `(${d.role_specialization})` : ''}
                </option>
              ))}
            </select>
          </div>
          <div className="admin-row">
            <label>Date *</label>
            <input
              type="date"
              required
              value={scheduleAppointmentForm.date}
              onChange={(e) => setScheduleAppointmentForm({...scheduleAppointmentForm, date: e.target.value})}
              min={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className="admin-row">
            <label>Time *</label>
            <input
              type="time"
              required
              value={scheduleAppointmentForm.time}
              onChange={(e) => setScheduleAppointmentForm({...scheduleAppointmentForm, time: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Purpose</label>
            <input
              type="text"
              value={scheduleAppointmentForm.purpose}
              onChange={(e) => setScheduleAppointmentForm({...scheduleAppointmentForm, purpose: e.target.value})}
              placeholder="e.g., Follow-up, Consultation"
            />
          </div>
          <div className="admin-row">
            <label>Duration (minutes)</label>
            <input
              type="number"
              value={scheduleAppointmentForm.duration_minutes}
              onChange={(e) => setScheduleAppointmentForm({...scheduleAppointmentForm, duration_minutes: parseInt(e.target.value) || 30})}
              min="15"
              step="15"
            />
          </div>
          <div className="admin-row">
            <label>Notes</label>
            <textarea
              value={scheduleAppointmentForm.notes}
              onChange={(e) => setScheduleAppointmentForm({...scheduleAppointmentForm, notes: e.target.value})}
              rows={3}
              placeholder="Additional notes..."
            />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">Schedule Appointment</button>
            <button
              type="button"
              className="btn"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
